// import React, { useEffect, useState, useRef } from 'react';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import Headstu from './Headstu';
// import { faUsers, faClipboardList } from "@fortawesome/free-solid-svg-icons";
// import axios from '../Axiosinstance';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import LearnImage from '../images/logopng.png'
// import {
//   Button,
//   Card,
//   CardContent,
//   Container,
//   Grid,
//   Typography,
//   makeStyles,
//   Dialog,
//   DialogContent,
//   DialogTitle,
//   IconButton,
//   Paper
// } from '@material-ui/core';

// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import Loader from '../Loader';
// import { baseURLdyte, Password, Username, baseURLdyteMeeting, dyteRestHeader } from '../common';
// import Meeting from '../StudentLogin/Meeting';
// import { Link, useNavigate, Routes, Route } from 'react-router-dom';
// import './Dashboard.css';
// import { faVideo, faFileInvoice, faEdit, faBook } from '@fortawesome/free-solid-svg-icons';
// import { decryptData, encryptData, removeBracketedText } from '../Axiosinstance';
// import StudentFeedbackPage from './Studentfeedback';
// import { faCommentDots } from '@fortawesome/free-solid-svg-icons';


// const useStyles = makeStyles((theme) => ({
//   container: {
//     maxWidth: '1200px',
//     margin: '3% auto',
//     padding: '20px',
//   },

//   card: {
//     marginBottom: '16px',
//     border: '1px solid #ccc',
//   },
//   cardImage: {
//     height: '100px',
//     width: '100%',
//   },
//   modal: {
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//   },
//   signatureCanvas: {
//     width: 500,
//     height: 300,
//   },
// }));

// function extractNamesFromArray(arr) {
//   return arr.map((item) => {
//     const match = item.match(/^([^(]+)/);
//     return match ? match[0].trim() : '';
//   });
// }

// const Man = () => {
//   const [batchId, setBatchId] = useState([]);
//   const [studentId, setStudentId] = useState([]);

//   const [batchData, setBatchData] = useState([]);
//   const [fetchedCourseData, setFetchedCourseData] = useState([]);
//   const [showDialog, setShowDialog] = useState(false);
//   const [selectedIndex, setSelectedIndex] = useState(null);
//   const [isLoading, setIsLoading] = useState(true);
//   const [courseId, setCourseId] = useState([]);
//   const classes = useStyles();
//   const navigate = useNavigate();
//   const studentTeacherId = decryptData(localStorage.getItem('studentteacherid'));

//   const extractId = (str) => {
//     const match = str.match(/\((\d+)\)/);
//     return match ? match[1] : '';
//   };

//   useEffect(() => {
//     const fetchBatchIds = async () => {
//       try {
//         setIsLoading(true);
//         const response = await axios.get(`registrationadvances/student/${studentTeacherId}/registration-advances`);
//         const batchData = response.data;
//         setBatchId(batchData[0].batch.id);
//         setStudentId(batchData[0].student.id)
//         console.log("hida", batchData[0].student.id)
//         setBatchData(batchData);
//       } catch (error) {
//         console.error('Error fetching batch data:', error);
//       } finally {
//         setIsLoading(false);
//       }
//     };

//     if (studentTeacherId) {
//       fetchBatchIds();
//     }
//   }, [studentTeacherId]);




//   const currentRemainingBalance = 0;
//   const totalPaid = 0;
//   const monthlyPaymentsInfo = [];
//   const filteredPayments = monthlyPaymentsInfo.filter(payment => payment.remainingBalance !== 0);


//   const courseNames = [];

//   useEffect(() => {
//     const fetchCourseData = async () => {
//       try {
//         const courseDataPromises = courseNames.map(async (courseName) => {
//           if (courseName !== '0') {
//             const response = await axios.get(`course/${courseName}`);
//             setCourseId(response.data.id);
//             return response.data.url;
//           } else {
//             return null;
//           }
//         });

//         const fetchedCourseData = await Promise.all(courseDataPromises);
//         setFetchedCourseData(fetchedCourseData);
//       } catch (error) {
//         console.error('Error fetching course data:', error);
//       }
//     };

//     if (courseNames.length > 0 && !fetchedCourseData.length) {
//       fetchCourseData();
//     }
//   }, [courseNames, fetchedCourseData]);



//   // const extractMeetingId = (link) => {
//   //   if (!link) return '';
//   //   const match = link.match(/id=([a-z0-9-]+)&/i);
//   //   return match ? match[1] : link.split('?id=')[1]?.split('&')[0];
//   // };

//   const extractMeetingId = (link) => {
//     const match = link.match(/id=([a-z0-9-]+)/i);
//     return match ? match[1] : null;
//   };

//   // const addParticipantToMeeting = async (meetingId) => {
//   //   try {
//   //     const basicAuth = btoa(`${Username}:${Password}`);
//   //     const loggedInUserId = decryptData(localStorage.getItem('userId'));
//   //     const userDetailsResponse = await axios.get(`home/user/${loggedInUserId}`);
//   //     const userDetails = userDetailsResponse.data;

//   //     const response = await axios.post(
//   //       `${baseURLdyte}/meetings/${meetingId}/participants`,
//   //       {
//   //         name: userDetails.name || 'student',
//   //         picture:
//   //           userDetails.profile_Url ||
//   //           'https://img.freepik.com/premium-vector/man-avatar-profile-picture-vector-illustration_268834-538.jpg',
//   //         preset_name: 'group_call_participant',
//   //         custom_participant_id: userDetails.sfid.toString(),
//   //       },
//   //       {
//   //         headers: {
//   //           Authorization: `Basic ${basicAuth}`,
//   //           'Content-Type': 'application/json',
//   //         },
//   //       }
//   //     );

//   //     const updatedAuthTokenLink = `${baseURLdyteMeeting}/meeting?id=${meetingId}&authToken=${response.data.data.token}`;
//   //     window.open(updatedAuthTokenLink);
//   //   } catch (error) {
//   //     console.error('Error adding participant:', error);
//   //   }
//   // };

//   const addParticipantToMeeting = async (meetingId) => {
//     try {
//       const basicAuth = btoa(`${Username}:${Password}`);
//       const loggedInUserId = decryptData(localStorage.getItem('userId'));
//       const userDetailsResponse = await axios.get(`home/user/${loggedInUserId}`);
//       const userDetails = userDetailsResponse.data;

//       const response = await axios.post(
//         `${baseURLdyte}/meetings/${meetingId}/participants`,
//         {
//           name: userDetails.name || 'student',
//           picture:
//             userDetails.profile_Url ||
//             'https://img.freepik.com/premium-vector/man-avatar-profile-picture-vector-illustration_268834-538.jpg',
//           preset_name: 'group_call_participant',
//           // custom_participant_id: userDetails.sfid.toString(),
//           // custom_participant_id: (userDetails.sfid || userDetails.id).toString(),
//           // custom_participant_id: String(userDetails.sfid ?? userDetails.id ?? Date.now()),
//           custom_participant_id: String(userDetails.id),
//         },
//         {
//           headers: {
//             // Authorization: `Basic ${basicAuth}`,
//             Authorization: dyteRestHeader,
//             'Content-Type': 'application/json',
//           },
//         }
//       );

//       // const updatedAuthTokenLink = `${baseURLdyteMeeting}/meeting?id=${meetingId}&authToken=${response.data.data.token}`;
//       // window.open(updatedAuthTokenLink);

//       const token = response.data?.data?.token;

//       console.log("DYTE RESPONSE:", response.data); // debug

//       if (!token) {
//         alert("❌ Token not received");
//         return;
//       }

//       // ✅ Correct Dyte meeting URL
//       const meetingUrl = `https://meet.dyte.io/${meetingId}?authToken=${token}`;

//       window.open(meetingUrl, '_blank');


//     } catch (error) {
//       console.error('Error adding participant:', error);
//     }
//   };

//   const [showAllDates, setShowAllDates] = useState(false);

//   const [showFeedback, setShowFeedback] = useState(false);

//   const [feedbackBatchCtx, setFeedbackBatchCtx] = useState({
//     batchId: null,
//     intakeId: null
//   });


//   const handleShowDialog = (index) => {
//     setSelectedIndex(index);
//     setShowDialog(true);
//   };

//   const handleCloseDialog = () => {
//     setShowDialog(false);
//     setSelectedIndex(null);
//   };
//   const handleKeyDown = (event) => {
//     if (event.key === 'Escape') {
//       handleCloseDialog();
//     }
//   };
//   return (
//     <Routes>
//       <Route path="/meeting/:meetingId" element={<Meeting />} />
//       <Route
//         path="/"
//         element={
//           isLoading ? (
//             <Loader />
//           ) : (
//             <div>
//               <Headstu batch={batchId} studentId={studentId} />
//               <ToastContainer position="bottom-right" />

//               <div className="containerd" style={{ textAlign: 'center', fontFamily: 'Montserrat, sans-serif', padding: '35px', marginTop: '-2%' }}>
//                 <h1 className="welcome-heading fangsong" style={{ fontSize: '2.8rem', textTransform: 'uppercase', letterSpacing: '0.1rem' }}>
//                   <span style={{ fontFamily: 'Courier New, Courier, monospace', letterSpacing: '0.1rem' }}>
//                     <span style={{ fontSize: '3.0rem', fontWeight: 'bolder', }}>AEG</span>
//                     <span style={{ fontSize: '3.0rem', fontWeight: 'bolder', }}> International</span>
//                     <span style={{ fontSize: '3.0rem', fontWeight: 'bolder', }}> College</span>
//                   </span>
//                 </h1>
//                 <h4 className="welcome-heading" style={{ fontSize: '2.4rem', fontWeight: 'bold', marginBottom: '10px' }}>
//                   Learning Management System
//                 </h4>
//               </div>

//               <Container
//                 maxWidth="xl"
//                 style={{
//                   // backgroundImage: `linear-gradient(rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 0.6)), url(${LearnImage})`,
//                   backgroundSize: '100%',
//                   backgroundRepeat: 'no-repeat',
//                   backgroundPosition: 'center calc(5px + 5px)',
//                   display: 'flex',
//                   alignItems: 'center',
//                   justifyContent: 'center',
//                 }}
//               >
//                 <Grid container spacing={4} justifyContent="center">
//                   {batchData.map((batch, index) => (
//                     <Grid item xs={12} md={10} key={index}>
//                       {/* Main Course Card */}
//                       <Card
//                         // component={Link}
//                         // to={`/content/${batch.batch.id}`}
//                         style={{
//                           display: 'flex',
//                           alignItems: 'center',
//                           padding: '30px',
//                           boxShadow: '0px 6px 12px rgba(0, 0, 0, 0.4)',
//                           transition: 'transform 0.3s ease-in-out, background-color 0.3s ease-in-out',
//                           borderRadius: '25px',
//                           textDecoration: 'none',
//                           backgroundColor: 'rgba(255, 255, 255, 0.9)',
//                         }}
//                         onMouseEnter={(e) => {
//                           e.currentTarget.style.transform = 'scale(1.02)';
//                           e.currentTarget.style.backgroundColor = '#f5f5f5';
//                         }}
//                         onMouseLeave={(e) => {
//                           e.currentTarget.style.transform = 'scale(1)';
//                           e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.9)';
//                         }}
//                       >
//                         <div style={{ flex: 1, textAlign: 'center' }}>
//                           <img
//                             src={batch.batch.courseImage}
//                             alt="Course cover"
//                             style={{
//                               width: '100%',
//                               maxHeight: '200px',
//                               objectFit: 'cover',
//                               borderRadius: '8px',
//                             }}
//                           />
//                         </div>

//                         {/* Course Details */}
//                         <CardContent
//                           style={{
//                             flex: 2,
//                             textAlign: 'left',
//                             padding: '20px',
//                             display: 'flex',
//                             flexDirection: 'column',
//                             gap: '8px',
//                           }}
//                         >
//                           <Typography variant="h4" style={{ fontWeight: 'bold', color: '#1565C0' }}>
//                             {batch.batch.course.split('(')[0]}
//                           </Typography>

//                           <Typography variant="h6" style={{ fontWeight: '600', color: '#333' }}>
//                             <strong>Intake ID:</strong> {batch.intakeId}
//                           </Typography>

//                           <Typography variant="h6" style={{ fontWeight: '600', color: '#333' }}>
//                             <strong>Trainer:</strong> {removeBracketedText(batch.batch.trainers.join(', '))}
//                           </Typography>
//                         </CardContent>
//                       </Card>

//                       {/* Action Cards */}
//                       <Grid container spacing={2} justifyContent="center" style={{ marginTop: '20px' }}>
//                         {(() => {
//                           const menuItems = [
//                             {
//                               icon: faCommentDots,
//                               text: 'Feedback',
//                               action: () => {
//                                 if (!batch?.batch?.id || !batch?.intakeId) {
//                                   alert("Batch info missing");
//                                   return;
//                                 }

//                                 setFeedbackBatchCtx({
//                                   batchId: batch.batch.id,
//                                   intakeId: batch.intakeId,
//                                 });

//                                 setShowFeedback(true);
//                               },
//                             },

//                             {
//                               icon: faVideo,
//                               text: 'Join Meeting',
//                               action: () => {
//                                 const meetingId = extractMeetingId(batch?.batch?.onlineclasslink);
//                                 if (meetingId) addParticipantToMeeting(meetingId);
//                                 else console.error('Meeting ID not found.');
//                               },
//                             },

//                             {
//                               icon: faEdit,
//                               text: 'PDF Assessment',
//                               link: `/PDFwritten/${encodeURIComponent(encryptData(batch.batch.id))}/${encodeURIComponent(encryptData(batch.intakeId))}`,
//                             },

//                             {
//                               icon: faBook,
//                               text: 'Course Content',
//                               link: `/content/${encodeURIComponent(encryptData(batch.batch.id))}`,
//                             },
//                           ];

//                           return menuItems.map((item, idx) => (
//                             <Grid item xs={12} sm={4} key={idx}>
//                               <Card
//                                 onClick={() => {
//                                   if (item.action) {
//                                     item.action();
//                                   } else if (item.link) {
//                                     navigate(item.link);
//                                   }
//                                 }}
//                                 style={{
//                                   display: 'flex',
//                                   alignItems: 'center',
//                                   justifyContent: 'space-between',
//                                   padding: '15px',
//                                   transition: 'transform 0.3s ease-in-out, background-color 0.3s ease-in-out',
//                                   boxShadow: '0px 3px 6px rgba(0,0,0,0.4)',
//                                   borderRadius: '15px',
//                                   backgroundColor: 'rgba(255, 255, 255, 0.9)',
//                                   minHeight: '80px',
//                                   cursor: 'pointer',
//                                 }}
//                                 onMouseEnter={(e) => {
//                                   e.currentTarget.style.transform = 'scale(1.02)';
//                                   e.currentTarget.style.backgroundColor = '#6DD5FA';
//                                 }}
//                                 onMouseLeave={(e) => {
//                                   e.currentTarget.style.transform = 'scale(1)';
//                                   e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.9)';
//                                 }}
//                               >
//                                 <CardContent
//                                   style={{
//                                     display: 'flex',
//                                     alignItems: 'center',
//                                     justifyContent: 'space-between',
//                                     width: '100%',
//                                   }}
//                                 >
//                                   <Typography
//                                     style={{
//                                       fontWeight: 'bold',
//                                       fontSize: '1.7rem',
//                                       textAlign: 'center',
//                                       flexGrow: 1,
//                                     }}
//                                   >
//                                     {item.text}
//                                   </Typography>

//                                   <FontAwesomeIcon
//                                     icon={item.icon}
//                                     size="1.5x"
//                                     style={{
//                                       backgroundColor: '#E3F2FD',
//                                       color: '#1976D2',
//                                       borderRadius: '50%',
//                                       padding: '15px',
//                                       width: '60px',
//                                       height: '60px',
//                                       marginLeft: 'auto', // Pushes the icon to the right
//                                     }}
//                                   />
//                                 </CardContent>
//                               </Card>
//                             </Grid>
//                           ));
//                         })()}
//                       </Grid>
//                     </Grid>
//                   ))}
//                 </Grid>
//               </Container>

//               {showFeedback && (
//                 <div
//                   style={{
//                     position: 'fixed',
//                     inset: 0,
//                     zIndex: 1400,
//                     background: 'rgba(0,0,0,0.35)',
//                     backdropFilter: 'blur(4px)',
//                     display: 'flex',
//                     justifyContent: 'flex-end',
//                   }}
//                   onClick={(e) => {
//                     if (e.target === e.currentTarget) setShowFeedback(false);
//                   }}
//                 >
//                   <div
//                     style={{
//                       width: '100%',
//                       maxWidth: 720,
//                       background: '#F7F6F3',
//                       overflowY: 'auto',
//                     }}
//                   >
//                     <StudentFeedbackPage
//                       batchId={feedbackBatchCtx.batchId}
//                       intakeId={feedbackBatchCtx.intakeId}
//                       studentId={studentId}
//                       onClose={() => setShowFeedback(false)}
//                     />
//                   </div>
//                 </div>
//               )}
//             </div>
//           )
//         }
//       />
//     </Routes>

//   );
// };

// export default Man;



import React, { useEffect, useState, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Headstu from './Headstu';
import { faUsers, faClipboardList } from "@fortawesome/free-solid-svg-icons";
import axios from '../Axiosinstance';
import 'bootstrap/dist/css/bootstrap.min.css';
import LearnImage from '../images/logopng.png';
import {
  Button, Card, CardContent, Container, Grid, Typography,
  makeStyles, Dialog, DialogContent, DialogTitle, IconButton, Paper
} from '@material-ui/core';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Loader from '../Loader';
import { baseURLdyte, Password, Username, baseURLdyteMeeting, dyteRestHeader } from '../common';
import Meeting from '../StudentLogin/Meeting';
import { Link, useNavigate, Routes, Route } from 'react-router-dom';
import './Dashboard.css';
import { faVideo, faFileInvoice, faEdit, faBook } from '@fortawesome/free-solid-svg-icons';
import { decryptData, encryptData, removeBracketedText } from '../Axiosinstance';
import StudentFeedbackPage from './Studentfeedback';
import { faCommentDots } from '@fortawesome/free-solid-svg-icons';
import dayjs from 'dayjs'; // ✅ NEW

const useStyles = makeStyles((theme) => ({
  container: { maxWidth: '1200px', margin: '3% auto', padding: '20px' },
  card: { marginBottom: '16px', border: '1px solid #ccc' },
  cardImage: { height: '100px', width: '100%' },
  modal: { display: 'flex', alignItems: 'center', justifyContent: 'center' },
  signatureCanvas: { width: 500, height: 300 },
}));

function extractNamesFromArray(arr) {
  return arr.map((item) => {
    const match = item.match(/^([^(]+)/);
    return match ? match[0].trim() : '';
  });
}

const Man = () => {
  const [batchId, setBatchId] = useState([]);
  const [studentId, setStudentId] = useState([]);
  const [registrationID, setRegistration] = useState([]); // ✅ NEW

  const [batchData, setBatchData] = useState([]);
  const [fetchedCourseData, setFetchedCourseData] = useState([]);
  const [showDialog, setShowDialog] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [courseId, setCourseId] = useState([]);
  const [checkingMeeting, setCheckingMeeting] = useState(false); // ✅ NEW

  const classes = useStyles();
  const navigate = useNavigate();
  const studentTeacherId = decryptData(localStorage.getItem('studentteacherid'));

  // ✅ NEW — Alumni detection
  const studentStatus = decryptData(localStorage.getItem('status'));
  const isAlumni = studentStatus === 'Alumni';

  const extractId = (str) => {
    const match = str.match(/\((\d+)\)/);
    return match ? match[1] : '';
  };

  useEffect(() => {
    const fetchBatchIds = async () => {
      try {
        setIsLoading(true);
        const response = await axios.get(`registrationadvances/student/${studentTeacherId}/registration-advances`);
        const batchData = response.data;
        setBatchId(batchData[0].batch.id);
        setStudentId(batchData[0].student.id);
        setRegistration(batchData[0].id); // ✅ NEW
        console.log("hida", batchData[0].id);
        setBatchData(batchData);
      } catch (error) {
        console.error('Error fetching batch data:', error);
      } finally {
        setIsLoading(false);
      }
    };

    if (studentTeacherId) {
      fetchBatchIds();
    }
  }, [studentTeacherId]);

  const currentRemainingBalance = 0;
  const totalPaid = 0;
  const monthlyPaymentsInfo = [];
  const filteredPayments = monthlyPaymentsInfo.filter(payment => payment.remainingBalance !== 0);
  const courseNames = [];

  useEffect(() => {
    const fetchCourseData = async () => {
      try {
        const courseDataPromises = courseNames.map(async (courseName) => {
          if (courseName !== '0') {
            const response = await axios.get(`course/${courseName}`);
            setCourseId(response.data.id);
            return response.data.url;
          } else {
            return null;
          }
        });
        const fetchedCourseData = await Promise.all(courseDataPromises);
        setFetchedCourseData(fetchedCourseData);
      } catch (error) {
        console.error('Error fetching course data:', error);
      }
    };

    if (courseNames.length > 0 && !fetchedCourseData.length) {
      fetchCourseData();
    }
  }, [courseNames, fetchedCourseData]);

  // ✅ UPDATED — added null guard
  const extractMeetingId = (link) => {
    if (!link) return null;
    const match = link.match(/id=([a-z0-9-]+)/i);
    return match ? match[1] : null;
  };

  const addParticipantToMeeting = async (meetingId) => {
    try {
      const loggedInUserId = decryptData(localStorage.getItem('userId'));
      const userDetailsResponse = await axios.get(`home/user/${loggedInUserId}`);
      const userDetails = userDetailsResponse.data;

      const response = await axios.post(
        `${baseURLdyte}/meetings/${meetingId}/participants`,
        {
          name: userDetails.name || 'student',
          picture:
            userDetails.profile_Url ||
            'https://img.freepik.com/premium-vector/man-avatar-profile-picture-vector-illustration_268834-538.jpg',
          preset_name: 'group_call_participant',
          custom_participant_id: String(userDetails.id),
        },
        {
          headers: {
            Authorization: dyteRestHeader,
            'Content-Type': 'application/json',
          },
        }
      );

      const token = response.data?.data?.token;
      console.log("DYTE RESPONSE:", response.data);

      if (!token) {
        alert("❌ Token not received");
        return;
      }

      const meetingUrl = `https://meet.dyte.io/${meetingId}?authToken=${token}`;
      window.open(meetingUrl, '_blank');

    } catch (error) {
      console.error('Error adding participant:', error);
    }
  };

  // ✅ NEW — copied from File 2
  const isMeetingLive = async (meetingId) => {
    try {
      const res = await axios.get(
        `${baseURLdyte}/meetings/${meetingId}/sessions`,
        {
          headers: {
            Authorization: dyteRestHeader,
            'Content-Type': 'application/json',
          },
        }
      );

      const rawData = res.data?.data;
      const sessionList = Array.isArray(rawData)
        ? rawData
        : Array.isArray(rawData?.sessions)
          ? rawData.sessions
          : [];

      if (!sessionList || sessionList.length === 0) return false;

      const liveSession = sessionList.find(
        (s) =>
          s.started_at &&
          !s.ended_at &&
          s.total_participants > 0
      );

      return !!liveSession;

    } catch (err) {
      console.error('Error checking live session:', err);
      return false;
    }
  };

  const [showAllDates, setShowAllDates] = useState(false);
  const [showFeedback, setShowFeedback] = useState(false);
  const [feedbackBatchCtx, setFeedbackBatchCtx] = useState({
    batchId: null,
    intakeId: null
  });

  const handleShowDialog = (index) => {
    setSelectedIndex(index);
    setShowDialog(true);
  };

  const handleCloseDialog = () => {
    setShowDialog(false);
    setSelectedIndex(null);
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Escape') {
      handleCloseDialog();
    }
  };

  return (
    <Routes>
      <Route path="/meeting/:meetingId" element={<Meeting />} />
      <Route
        path="/"
        element={
          isLoading ? (
            <Loader />
          ) : (
            <div>
              {/* ✅ UPDATED — pass registrationID */}
              <Headstu batch={batchId} studentId={studentId} registrationID={registrationID} />
              <ToastContainer position="bottom-right" />

              <div className="containerd" style={{ textAlign: 'center', fontFamily: 'Montserrat, sans-serif', padding: '35px', marginTop: '-2%' }}>
                <h1 className="welcome-heading fangsong" style={{ fontSize: '2.8rem', textTransform: 'uppercase', letterSpacing: '0.1rem' }}>
                  <span style={{ fontFamily: 'Courier New, Courier, monospace', letterSpacing: '0.1rem' }}>
                    <span style={{ fontSize: '3.0rem', fontWeight: 'bolder' }}>AEG</span>
                    <span style={{ fontSize: '3.0rem', fontWeight: 'bolder' }}> International</span>
                    <span style={{ fontSize: '3.0rem', fontWeight: 'bolder' }}> College</span>
                  </span>
                </h1>
                <h4 className="welcome-heading" style={{ fontSize: '2.4rem', fontWeight: 'bold', marginBottom: '10px' }}>
                  Learning Management System
                </h4>
              </div>

              <Container
                maxWidth="xl"
                style={{
                  backgroundSize: '100%',
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: 'center calc(5px + 5px)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <Grid container spacing={4} justifyContent="center">
                  {batchData.map((batch, index) => {

                    // ✅ NEW — schedule completion check (same as File 2)
                    const schedule = batch.scheduleDate || [];
                    const lastEndDate = schedule.length > 0 ? schedule[schedule.length - 1].endDate : null;
                    const isCompleted = lastEndDate ? dayjs(lastEndDate).isBefore(dayjs()) : false;

                    // ✅ NEW — role-based menu (no Payment Receipt for AEG)
                    const menuItems = isAlumni
                      ? [
                          {
                            icon: faCommentDots,
                            text: 'Feedback',
                            action: () => {
                              if (!batch?.batch?.id || !batch?.intakeId) {
                                alert("Batch info missing");
                                return;
                              }
                              setFeedbackBatchCtx({ batchId: batch.batch.id, intakeId: batch.intakeId });
                              setShowFeedback(true);
                            },
                          },
                          {
                            icon: faBook,
                            text: 'Course Content',
                            link: `/content/${encodeURIComponent(encryptData(batch?.batch?.id))}`,
                          },
                          {
                            icon: faEdit,
                            text: 'PDF Assessment',
                            link: `/PDFwritten/${encodeURIComponent(encryptData(batch.batch.id))}/${encodeURIComponent(encryptData(batch.intakeId))}`,
                          },
                        ]
                      : [
                          {
                            icon: faCommentDots,
                            text: 'Feedback',
                            action: () => {
                              if (!batch?.batch?.id || !batch?.intakeId) {
                                alert("Batch info missing");
                                return;
                              }
                              setFeedbackBatchCtx({ batchId: batch.batch.id, intakeId: batch.intakeId });
                              setShowFeedback(true);
                            },
                          },
                          ...(!isCompleted
                            ? [
                                {
                                  icon: faVideo,
                                  text: checkingMeeting ? 'Checking...' : 'Join Meeting',
                                  action: async () => {
                                    const meetingId = extractMeetingId(batch?.batch?.onlineclasslink);
                                    if (!meetingId) {
                                      toast.error('Meeting link not found.');
                                      return;
                                    }
                                    setCheckingMeeting(true);
                                    const live = await isMeetingLive(meetingId);
                                    setCheckingMeeting(false);

                                    if (!live) {
                                      toast.warning('The meeting has not started yet. Please wait for your trainer.');
                                      return;
                                    }
                                    addParticipantToMeeting(meetingId);
                                  },
                                },
                              ]
                            : []),
                          {
                            icon: faEdit,
                            text: 'PDF Assessment',
                            link: `/PDFwritten/${encodeURIComponent(encryptData(batch.batch.id))}/${encodeURIComponent(encryptData(batch.intakeId))}`,
                          },
                          {
                            icon: faBook,
                            text: 'Course Content',
                            link: `/content/${encodeURIComponent(encryptData(batch.batch.id))}`,
                          },
                        ];

                    return (
                      <Grid item xs={12} md={10} key={index}>
                        {/* Main Course Card — unchanged */}
                        <Card
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            padding: '30px',
                            boxShadow: '0px 6px 12px rgba(0, 0, 0, 0.4)',
                            transition: 'transform 0.3s ease-in-out, background-color 0.3s ease-in-out',
                            borderRadius: '25px',
                            textDecoration: 'none',
                            backgroundColor: 'rgba(255, 255, 255, 0.9)',
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.transform = 'scale(1.02)';
                            e.currentTarget.style.backgroundColor = '#f5f5f5';
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.transform = 'scale(1)';
                            e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.9)';
                          }}
                        >
                          <div style={{ flex: 1, textAlign: 'center' }}>
                            <img
                              src={batch.batch.courseImage}
                              alt="Course cover"
                              style={{ width: '100%', maxHeight: '200px', objectFit: 'cover', borderRadius: '8px' }}
                            />
                          </div>

                          <CardContent
                            style={{
                              flex: 2, textAlign: 'left', padding: '20px',
                              display: 'flex', flexDirection: 'column', gap: '8px',
                            }}
                          >
                            <Typography variant="h4" style={{ fontWeight: 'bold', color: '#1565C0' }}>
                              {batch.batch.course.split('(')[0]}
                            </Typography>
                            <Typography variant="h6" style={{ fontWeight: '600', color: '#333' }}>
                              <strong>Intake ID:</strong> {batch.intakeId}
                            </Typography>
                            <Typography variant="h6" style={{ fontWeight: '600', color: '#333' }}>
                              <strong>Trainer:</strong> {removeBracketedText(batch.batch.trainers.join(', '))}
                            </Typography>
                          </CardContent>
                        </Card>

                        {/* Action Cards */}
                        <Grid container spacing={2} justifyContent="center" style={{ marginTop: '20px' }}>
                          {menuItems.map((item, idx) => (
                            <Grid item xs={12} sm={4} key={idx}>
                              <Card
                                onClick={() => {
                                  if (item.action) item.action();
                                  else if (item.link) navigate(item.link);
                                }}
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'space-between',
                                  padding: '15px',
                                  transition: 'transform 0.3s ease-in-out, background-color 0.3s ease-in-out',
                                  boxShadow: '0px 3px 6px rgba(0,0,0,0.4)',
                                  borderRadius: '15px',
                                  backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                  minHeight: '80px',
                                  cursor: 'pointer',
                                }}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.transform = 'scale(1.02)';
                                  e.currentTarget.style.backgroundColor = '#6DD5FA';
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.transform = 'scale(1)';
                                  e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.9)';
                                }}
                              >
                                <CardContent
                                  style={{
                                    display: 'flex', alignItems: 'center',
                                    justifyContent: 'space-between', width: '100%',
                                  }}
                                >
                                  <Typography style={{ fontWeight: 'bold', fontSize: '1.7rem', textAlign: 'center', flexGrow: 1 }}>
                                    {item.text}
                                  </Typography>
                                  <FontAwesomeIcon
                                    icon={item.icon}
                                    size="1.5x"
                                    style={{
                                      backgroundColor: '#E3F2FD', color: '#1976D2',
                                      borderRadius: '50%', padding: '15px',
                                      width: '60px', height: '60px', marginLeft: 'auto',
                                    }}
                                  />
                                </CardContent>
                              </Card>
                            </Grid>
                          ))}
                        </Grid>
                      </Grid>
                    );
                  })}
                </Grid>
              </Container>

              {/* Feedback Slide-in Panel — unchanged */}
              {showFeedback && (
                <div
                  style={{
                    position: 'fixed', inset: 0, zIndex: 1400,
                    background: 'rgba(0,0,0,0.35)', backdropFilter: 'blur(4px)',
                    display: 'flex', justifyContent: 'flex-end',
                  }}
                  onClick={(e) => { if (e.target === e.currentTarget) setShowFeedback(false); }}
                >
                  <div style={{ width: '100%', maxWidth: 720, background: '#F7F6F3', overflowY: 'auto' }}>
                    <StudentFeedbackPage
                      batchId={feedbackBatchCtx.batchId}
                      intakeId={feedbackBatchCtx.intakeId}
                      studentId={studentId}
                      onClose={() => setShowFeedback(false)}
                    />
                  </div>
                </div>
              )}
            </div>
          )
        }
      />
    </Routes>
  );
};

export default Man;
